<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="PcWeb" :toName="title" cneterName="招聘职位" goPathName="PC网站"></Breadcrumb>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="currentFormLayout2.labelCol"
        :wrapper-col="currentFormLayout2.wrapperCol">
        <a-form-model-item label="职位" prop="jobPosition">
          <a-input
            v-model="ruleForm.jobPosition"
            placeholder="请输入"
            :maxLength="30"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item label="学历要求" prop="education">
          <a-input
            v-model="ruleForm.education"
            placeholder="请输入"
            :maxLength="30"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item label="经验要求" prop="experience">
          <a-input
            v-model="ruleForm.experience"
            placeholder="请输入"
            :maxLength="30"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item label="职位福利" prop="jobBonus">
          <a-input
            v-model="ruleForm.jobBonus"
            placeholder="请输入"
            :maxLength="30"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item label="薪资范围" prop="salary">
          <a-input
            v-model="ruleForm.salary"
            placeholder="请输入"
            :maxLength="30"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item label="工作地点" prop="defaultCityValue">
          <a-cascader
            style="max-width: 250px;"
            :options="provinceList"
            @change="onCityChange"
            :value='ruleForm.defaultCityValue'
            :showSearch="{ filter }"
            placeholder="国内目的地"
          />
          <a-input placeholder="详细地址" v-model="ruleForm.address" :maxLength="30"
                   style="max-width: 230px;margin-left: 20px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="职位描述" prop="jobDesc">
          <a-textarea
            v-model="ruleForm.jobDesc"
            placeholder="请输入"
            :rows="8"
            :maxLength="2000"
            style="max-width:600px;"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'AddPosition',
  components: {
    Breadcrumb
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      ruleForm: {
        jobPosition: '',
        education: '',
        experience: '',
        jobBonus: '',
        salary: '',
        jobDesc: '',
        address: '',
        defaultCityValue: [],
        workingCityId: '',
        workingCityName: '',
        workingCountyId: '',
        workingCountyName: '',
        workingProvinceId: '',
        workingProvinceName: ''
      },
      rules: {
        jobPosition: [{ required: true, message: '请输入', trigger: 'blur' }],
        education: [{ required: true, message: '请输入', trigger: 'blur' }],
        experience: [{ required: true, message: '请输入', trigger: 'blur' }],
        jobBonus: [{ required: true, message: '请输入', trigger: 'blur' }],
        salary: [{ required: true, message: '请输入', trigger: 'blur' }],
        jobDesc: [{ required: true, message: '请输入', trigger: 'blur' }],
        defaultCityValue: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      submitLoading: false,
      provinceList: [],
      id: '',
      title: '添加'
    }
  },
  mounted() {
    this.getProvinceList()
  },
  activated() {
    this.id = this.$route.query.id
    this.title = this.id ? '编辑' : '添加'
    this.goReset()
    if (this.id) {
      this.getDetails()
    }
  },
  methods: {
    getDetails() {
      let url = '/pc/v2/job/query/' + this.id
      this.getHttpServices().getUserService().get(url)
        .then(res => {
          this.ruleForm = res
          this.ruleForm.defaultCityValue = [this.ruleForm.workingProvinceId, this.ruleForm.workingCityId, this.ruleForm.workingCountyId]
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    getProvinceList() {
      this.getHttpServices().getBaseService().get('province/getProvinceCityCounty').then(res => {
        this.provinceList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    onCityChange(value, selectedOptions) {
      this.getLogUtils().errorWithTag('value', value)
      this.getLogUtils().errorWithTag('selectedOptions', selectedOptions)
      if (value && value.length && selectedOptions && selectedOptions.length) {
        this.ruleForm.defaultCityValue = [value[0], value[1], value[2]]
        this.ruleForm.workingCityId = value[1]
        this.ruleForm.workingCountyId = value[2]
        this.ruleForm.workingProvinceId = value[0]
        this.ruleForm.workingProvinceName = selectedOptions[0].label
        this.ruleForm.workingCityName = selectedOptions[1].label
        this.ruleForm.workingCountyName = selectedOptions[2].label

      } else {
        this.ruleForm.defaultCityValue = []
      }
    },
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    handleOk() {
      let params = {
        ...this.ruleForm,
        id: this.id
      }
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/job/save', params)
        .then(res => {
          this.$message.success('保存成功')
          this.submitLoading = false
          this.goBack()
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.image-hint {
  margin-left: 20px;
}
</style>